import React from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {cabinetLogout} from "../../store/cabinet/action";
import {NAV_ITEMS, isActivePath, formatNumber} from "../cabinetShell/config";
import DsIcon from "../_UI/dsIcon";
import CommunityPromo from "../_UI/communityPromo";
import LangSwitcher from "../langSwitcher";

import avatarPlaceholder from '../../theme/assets/redesign/avatar_placeholder.webp';
import editIcon from '../../theme/assets/redesign/edit.svg';


const CabinetSidebar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {t} = useTranslation();

    const userData = useSelector(store => store.cabinet.userData);
    const tokens = Number(userData?.user?.tokens) || 0;
    const usdt = tokens * (Number(userData?.token_rate) || 0);

    return (
        <aside className={Styles.container}>
            <div className={Styles.profile}>
                <div className={Styles.avatar}>
                    <img src={userData?.user?.avatar || avatarPlaceholder} alt={userData?.user?.username || ''}/>
                </div>
                <div className={Styles.identity}>
                    <div className={Styles.caption}>{t('Ваш никнейм')}</div>
                    <div className={Styles.nameRow} onClick={() => navigate('/settings')}>
                        <span className={Styles.name}>{userData?.user?.username}</span>
                        <img src={editIcon} alt="edit" width="16" height="16"/>
                    </div>
                </div>
            </div>

            <div className={Styles.balanceChip}>
                <div className={Styles.caption}>{t('Ваш баланс токенов')}:</div>
                <div className={Styles.balanceValue}>
                    {/* группы не разрываются: при длинных числах перенос идёт после «≈» */}
                    <span className={Styles.group}>
                        <span>{formatNumber(tokens)}</span>
                        <span className={Styles.red}>FTF</span>
                        <span className={Styles.muted}>≈</span>
                    </span>
                    <span className={Styles.group}>
                        <span>{formatNumber(usdt)}</span>
                        <span className={Styles.green}>USDT</span>
                    </span>
                </div>
            </div>

            <nav className={Styles.nav}>
                {NAV_ITEMS.map(item => {
                    const active = isActivePath(pathname, item.path);
                    return (
                        <div
                            key={item.path}
                            className={`${Styles.navItem} ${active ? Styles.navItemActive : ''}`}
                            onClick={() => navigate(`/${item.path}`)}
                        >
                            <DsIcon name={item.icon} size={24}/>
                            <span>{t(item.label)}</span>
                            {active ? <i className={Styles.indicator}/> : null}
                        </div>
                    );
                })}
            </nav>

            <div className={Styles.lang}>
                <LangSwitcher isNotHided={true}/>
            </div>

            <div className={Styles.spacer}/>

            <CommunityPromo compact/>

            <button type="button" className={Styles.logout} onClick={() => dispatch(cabinetLogout())}>
                <DsIcon name="logout" size={18}/>
                <span>{t('Выход')}</span>
            </button>
        </aside>
    );
};

export default CabinetSidebar;
